export function Close({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.4629 0.627319C14.5767 0.513509 14.7525 0.499017 14.8818 0.584351L14.9346 0.627319C15.0482 0.741232 15.0619 0.916969 14.9766 1.04626L14.9346 1.099L8.85547 7.17712L8.50195 7.53064L14.9346 13.9633C15.0482 14.0772 15.062 14.2529 14.9766 14.3822L14.9336 14.4349C14.8196 14.5485 14.6439 14.5625 14.5146 14.4769L14.4629 14.4349L8.03027 8.00232L7.67676 8.35583L1.59863 14.4349C1.48478 14.5487 1.30903 14.5622 1.17969 14.4769L1.12695 14.4349C1.01298 14.3209 0.99846 14.1445 1.08398 14.015L1.12695 13.9633L7.20508 7.88416L7.55957 7.53064L7.20508 7.17712L1.12695 1.099C1.01318 0.985226 0.998871 0.809393 1.08398 0.680054L1.12695 0.627319C1.24079 0.513477 1.41654 0.499073 1.5459 0.584351L1.59863 0.627319L7.67676 6.70642L8.03027 7.05994L14.4629 0.627319Z"
          fill="currentColor"
          stroke="currentColor"
        />
      </svg>
    </span>
  );
}
